import { render, staticRenderFns } from "./Loadtab.vue?vue&type=template&id=700b9bf5"
import script from "./Loadtab.vue?vue&type=script&lang=js"
export * from "./Loadtab.vue?vue&type=script&lang=js"
import style0 from "./Loadtab.vue?vue&type=style&index=0&id=700b9bf5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports